// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';


class AddTournamentTeam extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      teams: [],
      groups: [],
      tournament_team_details: {
        team: '',
        group: '',
      },
      data_uploaded: false,
      data_error: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }


  componentDidMount() {
    this.getTeamList();
    console.log(this.state);
  }

  getTeamList() {
     const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_team/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState({ teams: data.teams, groups: data.groups});
        })
       .catch(error => error);
  }

  postaddTournamentTeam(data, props) {
    if(!data.team){data.team=this.state.teams[0].id}
    const url = `${getLocationOrigin()}/eagleeye/create_tournament_team/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'tournament_id': this.state.id,
                        'team': data.team,
                        'group': data.group,
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.tournament_team_details);
    new_selected_one[name] = event.target.value
    this.setState({tournament_team_details: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postaddTournamentTeam(this.state.tournament_team_details, this.props);
    console.log('post');
    console.log(this.state);
  }

  render() {
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Add Tournament Team</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Team
              </div>
              <select name="team" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                {
                  this.state.teams.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Group
              </div>
              <select name="group" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                {
                  this.state.groups.map((x, index) => (
                  <option key={x} value={x}>{x}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default AddTournamentTeam;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTournamentTeam/index.js